$(function(){
  $(".CustomDenim .floating-button .btn, .gsrtd ").click(function() {
    $('html, body').animate({
        scrollTop: $(".PlusCustomForm").offset().top - 100
    }, 2000);
});

  $('#ContactFormCountry option[value="United States"]').attr('selected','selected');
$('.benefitssec .collapsible-trigger').click();
})

$(function(){
   if (window.location.href.indexOf("products") > -1) {
  $(document).bind("contextmenu",function(event){
 var container = $(".product-single__title");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(event.target) && container.has(event.target).length === 0) 
    {
return false;
    }  
});
   }
  var selected = $(".variant-input input[type='radio']:checked").val();
if(selected == 'Made to Measure'){

     $('.dimensions,.dimensions_fields').show(); 
  $('.dimen_check_1').click();
    }
    else{
      $('.dimensions,.dimensions_fields').hide();
    }
  $(document).on('click','.variant-input',function(){
    var value = $(this).find('input').val();
    if(value == 'Made to Measure'){
     $('.dimensions,.dimensions_fields').show(); 
       $('.dimen_check_1').click();
    }
    else{
      $('.dimensions_fields_inner').each(function(){
        $(this).find('input').val('');
      });
      $('.dimension_input').each(function () {
        $(this).find('input').val(''); 
      });
      $('.dimensions,.dimensions_fields').hide();
    }
  });
  $(document).on('click','.dimen_check_1',function (){
    $(this).val("IN");
  });
   $(document).on('click','.dimen_check_2',function (){
    $(this).val("CM");
  });
$(document).on('click','.dimension_input',function(){
  $('.dimension_input').removeClass('dimension_checked');
   $(this).addClass('dimension_checked');
});
  $(".dimension_input input").click(function() {
    "CM" == $(this).val() ? $(".size_demensions input").each(function() {
      $(this).attr("placeholder", "cm"), $(this).prev("p").children("span").html("(cm)")
    }) : $(".size_demensions input").each(function() {
      $(this).attr("placeholder", "in"), $(this).prev("p").children("span").html("(in)")
    }), $(".dimension_input input").each(function() {
      $(this).parent(".dimension_input").removeClass("dimension_checked")
    }), $(this).parent(".dimension_input").addClass("dimension_checked")
  });
      $('.cust_popup_form_btns .customizebtn').on('click', function(e) {
  e.preventDefault();
  $('#customise').toggleClass('is-visible');
});
      $('.cust_popup_form_btns .askquestion').on('click', function(e) {
  e.preventDefault();
  $('#askquestion').toggleClass('is-visible');
});
  
      $('.closecustomize').on('click',function(){
      $('.modal').removeClass('is-visible');   
      });
       $('.menchart').on('click', function(e) {
  e.preventDefault();
  $('.MainContainerMen').toggleClass('is-visible');
});
    $('.womenchart').on('click', function(e) {
  e.preventDefault();
  $('.MainContainerWomen').toggleClass('is-visible');
});
$('#size_cart_men .measure .size-chart-inches').click(function(){
    $(this).addClass('active');
    $('#size_cart_men .measure .size-chart-cm').removeClass('active');
    $('#size_cart_men .size-chart-inches-target').removeClass('hidden');
    $('#size_cart_men .size-chart-cm-target').addClass('hidden')
  });
  $('#size_cart_men .measure .size-chart-cm').click(function(){
    $(this).addClass('active');
    $('#size_cart_men .measure .size-chart-inches').removeClass('active');
    $('#size_cart_men .size-chart-inches-target').addClass('hidden');
    $('#size_cart_men .size-chart-cm-target').removeClass('hidden')
  });

  $('#size_cart_women .measure .size-chart-inches').click(function(){
    $(this).addClass('active');
    $('#size_cart_women .measure .size-chart-cm').removeClass('active');
    $('#size_cart_women .size-chart-inches-target').removeClass('hidden');
    $('#size_cart_women .size-chart-cm-target').addClass('hidden')
  });
  $('#size_cart_women .measure .size-chart-cm').click(function(){
    $(this).addClass('active');
    $('#size_cart_women .measure .size-chart-inches').removeClass('active');
    $('#size_cart_women .size-chart-inches-target').addClass('hidden');
    $('#size_cart_women .size-chart-cm-target').removeClass('hidden')
  });

  $(".sizechart-cst.MainContainerMen .men_tableCus.size-chart-inches-target td").hover(

    function(){
      console.log("HOVER 1");
      var limit = $(this).parent("tr").attr("data-max");
      limit = limit-1;
      limit = parseInt(limit);
      var tdNum = $(this).attr("data-number");
      tdNum = parseInt(tdNum);
      $(this).toggleClass("dark_hover");
      $(this).prevUntil(".first_colum","td").toggleClass("light_hover");
      $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
      var maximum = $(this).parent("tr").attr("data-max");
      $(".men_tableCus.size-chart-inches-target thead tr th").each(function(){
        var thNum = $(this).attr("data-number");
        if(thNum == tdNum){
          $(this).toggleClass("dark_hover");
        }
      })
      $(".MainContainerMen .men_tableCus.size-chart-inches-target tbody  tr").each(function(index){
        if(index < limit){

          $(this).children("td").each(function(){
            var tdNumAll = $(this).attr("data-number");
            tdNumAll = parseInt(tdNumAll);
            if(tdNumAll == tdNum){
              $(this).toggleClass("light_hover");
            }
          })
        }
      })
      $(this).removeClass("light_hover");
    })

  $(".sizechart-cst.MainContainerMen .men_tableCus.size-chart-cm-target td").hover(

    function(){
      console.log("HOVER 2");
      var limit = $(this).parent("tr").attr("data-max");
      var tdNum = $(this).attr("data-number");
      $(this).toggleClass("dark_hover");
      $(this).prevUntil(".first_colum","td").toggleClass("light_hover");
      $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
      var maximum = $(this).parent("tr").attr("data-max");
      $(".men_tableCus.size-chart-cm-target thead tr th").each(function(){
        var thNum = $(this).attr("data-number");
        if(thNum == tdNum){
          $(this).toggleClass("dark_hover");
        }
      })
      $(".MainContainerMen .men_tableCus.size-chart-cm-target tbody  tr").each(function(index){

        if(index < limit-1){
          $(this).children("td").each(function(){
            var tdNumAll = $(this).attr("data-number");
            if(tdNumAll == tdNum){
              $(this).toggleClass("light_hover");
            }
          })
        }
      })
      $(this).removeClass("light_hover");
    })

  $(".MainContainerWomen .sizechart-cst .women_tableCus.size-chart-inches-target td").hover(

    function(){
      console.log("HOVER 3");
      var limit = $(this).parent("tr").attr("data-max");
      var tdNum = $(this).attr("data-number");
      $(this).toggleClass("dark_hover");
      $(this).prevUntil(".first_colum","td").toggleClass("light_hover");
      $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
      var maximum = $(this).parent("tr").attr("data-max");
      $(".women_tableCus.size-chart-inches-target thead tr th").each(function(){
        var thNum = $(this).attr("data-number");
        if(thNum == tdNum){
          $(this).toggleClass("dark_hover");
        }
      })
      $(".MainContainerWomen .women_tableCus.size-chart-inches-target tbody  tr").each(function(index){

        if(index < limit-1){
          $(this).children("td").each(function(){
            var tdNumAll = $(this).attr("data-number");
            if(tdNumAll == tdNum){
              $(this).toggleClass("light_hover");
            }
          })
        }
      })
      $(this).removeClass("light_hover");
    })

  $(".MainContainerWomen .sizechart-cst .women_tableCus.size-chart-cm-target td").hover(

    function(){
      console.log("HOVER 4");
      var limit = $(this).parent("tr").attr("data-max");
      var tdNum = $(this).attr("data-number");
      $(this).toggleClass("dark_hover");
      $(this).prevUntil(".first_colum","td").toggleClass("light_hover");
      $(this).parent("tr").children(".first_colum").toggleClass("dark_hover");
      var maximum = $(this).parent("tr").attr("data-max");
      $(".women_tableCus.size-chart-cm-target thead tr th").each(function(){
        var thNum = $(this).attr("data-number");
        if(thNum == tdNum){
          $(this).toggleClass("dark_hover");
        }
      })
      $(".MainContainerWomen .women_tableCus.size-chart-cm-target tbody  tr").each(function(index){

        if(index < limit-1){
          $(this).children("td").each(function(){
            var tdNumAll = $(this).attr("data-number");
            if(tdNumAll == tdNum){
              $(this).toggleClass("light_hover");
            }
          })
        }
      })
      $(this).removeClass("light_hover");
    })

  $(".MenTab").click(function(){
    $(this).addClass("active");
    $(".WomenTab").removeClass("active");
    $("#size_cart_men").css("display","block");
    $("#size_cart_women").css("display","none");
  })
  $(".WomenTab").click(function(){
    $(this).addClass("active");
    $(".MenTab").removeClass("active");
    $("#size_cart_men").css("display","none");
    $("#size_cart_women").css("display","block");
  })

})
